<template>
  <div id="history" class="con">
    <navheader></navheader>
    <fixheader></fixheader>
    <div class="our_history"></div>
    <div class="container">
      <el-row :gutter="50">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div class="organ mess" style="margin: 50px 0 0 0;">
            <el-link :underline="false">公司历程</el-link>
           <!-- <p style="font-size: 22px !important; font-weight: bolder;">CONMPANY HISTORY</p> -->
          </div>
        </el-col>
      </el-row>
      <el-divider class="space"></el-divider>
      <div id="conference-timeline">
        <el-timeline>
          <template v-for="item in historys">
            <el-timeline-item :timestamp="item.title?'':item.historysj" placement="top" :class="item.title?'timetop':''">
              <el-card>
                <h3 v-if="item.title">{{item.title}}</h3>
                <h3 v-if="!item.title" v-html="item.content" style="color: rgba(0,0,0,0.6);">{{item.content}}</h3>
              </el-card>
            </el-timeline-item>
          </template>
        </el-timeline>
      </div>
    </div>
    <filing></filing>
  </div>
</template>

<script>
  import navheader from '@/components/Navheader.vue'
  import fixheader from '@/components/Fixheader.vue'
  import filing from '@/components/Filing.vue'
  export default {
    name: 'about',
    data() {
      return {
        visible: false,
        historys: []
      }
    },
    components: {
      navheader,
      fixheader,
      filing
    },
    beforeCreate() {
      this.axios.get(this.$http + "/api/index/getHistory")
        .then((res) => {
          this.historys = res.data.data;
        })
        .catch((err) => {})
    },
    mounted: function() {
      this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
      })

    },
    methods: {
      loadHistory() {

      },
    }
  }
</script>

<style scoped>
  @import "../assets/css/font-awesome.min.css";
</style>
<style>
  .timetop h3 {
    color: rgba(255, 255, 255, 1) !important;
    text-align: center;
  }


  .el-timeline-item {
    padding-bottom: 80px !important;
  }

  .timetop .el-timeline-item__content {
    width: 50%;
    margin-left: 17.5%;
    border-radius: 50%;

  }

  #history .timetop .el-card.is-always-shadow {
    border-radius: 30px;
    background-color: #5cb6ff;
    border: none;
    color: #fff;
  }

  .timetop .el-timeline-item__timestamp {
    width: 0;
  }

  #history .mess {
    margin-top: 30px !important;
  }

  #history .mess a {
    font-size: 35px !important;
  }

  #history .bottom-mes {
    margin-bottom: 50px;
  }

  #history .bottom-mes p {
    line-height: 30px !important;
  }

  #history div.el-divider {
    height: 3px !important;
    position: relative;
  }

  #history #conference-timeline {
    display: block;
  }

  #history div.el-divider:before {
    position: absolute;
    content: "";
    top: 0;
    width: 160px;
    height: 3px;
    background-color: rgba(0, 0, 0, 0.6);
    right: calc(50% - 80px);
  }

  #history #small-timeline {
    display: none;
  }

  #history #small-timeline>ul>li:nth-child(4n+1)>div.el-timeline-item__node {
    background-color: #1b75bc;
  }

  #history #small-timeline>ul>li:nth-child(4n+2)>div.el-timeline-item__node {
    background-color: #f7931d;
  }

  #history #small-timeline>ul>li:nth-child(4n+3)>div.el-timeline-item__node {
    background-color: #8cc63f;
  }

  #history #small-timeline>ul>li:nth-child(4n+4)>div.el-timeline-item__node {
    background-color: #00a79d;
  }

  #history #small-timeline>ul>li:nth-child(4n+1)>div.el-timeline-item__tail {
    border-left: 2px solid #1b75bc;
  }

  #history #small-timeline>ul>li:nth-child(4n+2)>div.el-timeline-item__tail {
    border-left: 2px solid #f7931d;
  }

  #history #small-timeline>ul>li:nth-child(4n+3)>div.el-timeline-item__tail {
    border-left: 2px solid #8cc63f;
  }

  #history #small-timeline>ul>li:nth-child(4n+4)>div.el-timeline-item__tail {
    border-left: 2px solid #00a79d;
  }

  #history .el-timeline-item__timestamp.is-top {
    font-size: 18px;
    padding-top: 0 !important;
  }

  #history .el-card.is-always-shadow {
    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, .4) !important;
  }

  #conference-timeline {
    position: relative;
    max-width: 1300px;
    width: 100%;
    margin: 60px auto;

  }

  #conference-timeline>.conference-top {
    position: absolute;
    left: calc(50% - 82px);
    width: 160px;
    height: 160px;
    border: 4px solid rgba(30, 92, 167, 1);
    background-color: rgba(255, 255, 255, 1);
    border-radius: 100%;
    text-align: center;
    top: -60px;
  }

  #conference-timeline .conference-timeline-content:nth-child(4n+1)>div.timeline-article>div.meta-date {
    background-color: #1b75bc;
  }

  #conference-timeline .conference-timeline-content:nth-child(4n+2)>div.timeline-article>div.meta-date {
    background-color: #f7931d;
  }

  #conference-timeline .conference-timeline-content:nth-child(4n+3)>div.timeline-article>div.meta-date {
    background-color: #8cc63f;
  }

  #conference-timeline .conference-timeline-content:nth-child(4n+4)>div.timeline-article>div.meta-date {
    background-color: #00a79d;
  }

  #conference-timeline>.conference-top>div:nth-child(1) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 30px;
    width: 100%;
    text-align: center;
    color: rgba(30, 92, 167, 1);
    font-weight: bolder;
  }

  #conference-timeline>.conference-top>div:nth-child(2) {
    position: absolute;
    top: 70%;
    transform: translateY(-70%);
    color: rgba(30, 92, 167, 1);
    font-size: 12px;
    width: 100%;
    text-align: center;
  }


  #conference-timeline:after {
    content: "";
    bottom: 0;
  }

  #conference-timeline .conference-center-line {
    position: absolute;
    width: 3px;
    height: calc(100% - 140px);
    top: 0;
    left: 50%;
    margin-left: -3px;
    background: rgba(0, 0, 0, 0.7);
    z-index: -1;
  }


  #conference-timeline .conference-timeline-content {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  #conference-timeline .conference-timeline-content:nth-child(1) {
    padding-top: 64px !important;
  }

  .timeline-article {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    margin: 20px 0;
    padding: 15px;
  }

  .timeline-article .contents {
    position: relative;
    width: 38%;
    border: 1px solid #ddd;
    background-color: #fff;
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, .2);
    padding: 27px 25px;
  }

  .timeline-article .contents>p {
    z-index: 2 !important;
  }

  #conference-timeline .conference-timeline-content:nth-child(1) {
    padding-top: 167px !important;
  }

  #conference-timeline .conference-timeline-content:nth-child(2n+1)>div.timeline-article>div.contents {
    float: left;
  }

  #conference-timeline .conference-timeline-content:nth-child(2n+2)>div.timeline-article>div.contents {
    float: right;
  }

  .timeline-article p:nth-child(1) {
    font-size: 30px;
    margin-bottom: 20px;
    width: 100%;
    font-weight: bolder;
  }

  .timeline-article p {
    padding: 0;
    font-weight: bold;
    color: #242424;
    font-size: 14px;
    line-height: 24px;
    position: relative;
  }

  .timeline-article p span.article-number {
    position: absolute;
    font-weight: bold;
    font-size: 44px;
    top: 10px;
    left: -60px;
    color: #00b0bd;
  }

  .timeline-article .content-left:before,
  .timeline-article .content-right:before {
    position: absolute;
    top: 20px;
    font-size: 23px;
    font-family: "FontAwesome";
    color: #fff;
  }

  .timeline-article .meta-date {
    position: absolute;
    top: 0;
    left: 50%;
    width: 160px;
    height: 80px;
    border: 3px solid rgba(187, 189, 192, 1);
    margin-left: -80px;
    border-radius: 10px;
    color: #fff;
    background: #00b0bd;
  }

  .timeline-article .meta-date .date,
  .timeline-article .meta-date .month {
    display: block;
    text-align: center;
    font-weight: bold;
  }

  .timeline-article .meta-date .date {
    font-size: 25px;
    line-height: 76px;
  }

  .timeline-article .meta-date .month {
    font-size: 18px;
    line-height: 10px;
    /*===== // Vertical Timeline =====*/
    /*===== Resonsive Vertical Timeline =====*/
  }

  #conference-timeline .conference-timeline-content:nth-child(2n+1)>div.timeline-article>div.contents::before {
    content: "" !important;
    position: absolute;
    right: 0;
    top: 0;
    background-color: #fff;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  #conference-timeline .conference-timeline-content:nth-child(2n+1)>div.timeline-article>div.contents::after {
    content: "";
    top: 21px;
    right: -10px;
    position: absolute;
    display: inline-block;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 10px;
    border-color: #fff #fff transparent #fff;
    transform: rotate(45deg);
    box-shadow: 2px -2px 20px rgba(0, 0, 0, 0.4);
  }

  #conference-timeline .conference-timeline-content:nth-child(2n+2)>div.timeline-article>div.contents::before {
    content: "" !important;
    position: absolute;
    left: 1px;
    top: 0;
    background-color: #fff;
    width: 100%;
    height: 100%;
    z-index: 1;
    box-shadow: 0 !important;
  }

  #conference-timeline .conference-timeline-content:nth-child(2n+2)>div.timeline-article>div.contents::after {
    content: "";
    top: 21px;
    left: -10px;
    position: absolute;
    display: inline-block;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 10px;
    border-color: #fff transparent #fff #fff;
    transform: rotate(45deg);
    box-shadow: 2px -2px 20px rgba(0, 0, 0, 0.4);
  }

  @media only screen and (max-width: 900px) {
    .content-left::before {
      background-color: transparent !important;
    }

    #history #conference-timeline {
      display: none !important;
    }

    #history #small-timeline {
      display: block !important;
    }

    #conference-timeline .conference-timeline-content:nth-child(2n+1)>div.timeline-article>div.contents {
      float: right;
    }

    .timeline-article .content-left::after {
      content: "" !important;
      top: 21px !important;
      right: -10px !important;
      position: absolute !important;
      display: inline-block !important;
      width: 0px !important;
      height: 0px !important;
      border: none !important;
      transform: rotate(0) !important;
      box-shadow: none !important;
    }

    .timeline-article .content-right::before {
      content: "" !important;
      position: absolute !important;
      left: 0px !important;
      top: 0px !important;
      background: transparent !important;
      width: 0 !important;
      height: 0 !important;
      z-index: 2 !important;
      box-shadow: none !important;
    }

    .content-right::before {
      background-color: transparent !important;
    }

    .timeline-article .content-right::after {
      content: "" !important;
      top: 21px !important;
      right: -10px !important;
      position: absolute !important;
      display: inline-block !important;
      width: 0px !important;
      height: 0px !important;
      border: none !important;
      transform: rotate(0) !important;
      box-shadow: none !important;
    }

    .timeline-article .content-right::before {
      content: "" !important;
      position: absolute !important;
      left: 0px !important;
      top: 0px !important;
      background: transparent !important;
      width: 0 !important;
      height: 0 !important;
      z-index: 2 !important;
      box-shadow: none !important;
    }

    #conference-timeline:before,
    #conference-timeline:after {
      left: 8px;
      transform: none;
    }

    #conference-timeline .conference-center-line {
      margin-left: 0;
      left: 55px;
    }

    .timeline-article .meta-date {
      margin-left: 0;
      left: 16px;
    }

    .timeline-article .content-left,
    .timeline-article .content-right {
      width: auto;
      float: none;
      margin-left: 110px;
      padding: 10px 25px;
      min-height: 53px;
    }

    .timeline-article .content-left {
      margin-bottom: 20px;
    }

    .timeline-article .content-left:before {
      content: "\f0d9";
      right: auto;
      left: -8px;
    }

    .timeline-article .content-right:before {
      display: none;
    }

    #conference-timeline::after {
      left: 15px !important;
    }
  }

  @media only screen and (max-width: 400px) {
    /*===== // Resonsive Vertical Timeline =====*/

    .content-left::before {
      background-color: transparent !important;
    }

    #history #conference-timeline {
      display: none !important;
    }

    #history #small-timeline {
      display: block !important;
    }

    #conference-timeline .conference-timeline-content:nth-child(2n+1)>div.timeline-article>div.contents {
      float: right;
    }

    .timeline-article .content-left::after {
      content: "" !important;
      top: 21px !important;
      right: -10px !important;
      position: absolute !important;
      display: inline-block !important;
      width: 0px !important;
      height: 0px !important;
      border: none !important;
      transform: rotate(0) !important;
      box-shadow: none !important;
    }

    .timeline-article .content-right::before {
      content: "" !important;
      position: absolute !important;
      left: 0px !important;
      top: 0px !important;
      background: transparent !important;
      width: 0 !important;
      height: 0 !important;
      z-index: 2 !important;
      box-shadow: none !important;
    }

    .content-right::before {
      background-color: transparent !important;
    }

    .timeline-article .content-right::after {
      content: "" !important;
      top: 21px !important;
      right: -10px !important;
      position: absolute !important;
      display: inline-block !important;
      width: 0px !important;
      height: 0px !important;
      border: none !important;
      transform: rotate(0) !important;
      box-shadow: none !important;
    }

    .timeline-article .content-right::before {
      content: "" !important;
      position: absolute !important;
      left: 0px !important;
      top: 0px !important;
      background: transparent !important;
      width: 0 !important;
      height: 0 !important;
      z-index: 2 !important;
      box-shadow: none !important;
    }

    .timeline-article p {
      margin: 0;
    }

    .timeline-article p span.article-number {
      display: none;
    }
  }

  #conference-timeline {
    padding: 0 20px;
  }

  .el-timeline-item__tail {
    left: calc(50% - 1px);
  }

  .el-timeline-item__node--normal {
    left: calc(50% - 6px);
  }

  .el-timeline-item__wrapper {
    padding-left: 0;
    display: flex;
  }

  .el-timeline-item__timestamp {
    width: 48%;
    text-align: right;
    margin-right: 100px;
  }

  .el-timeline-item__content {
    width: 48%;

  }
</style>



// WEBPACK FOOTER //
// src/content/Our_history.vue